<template>
    <div class="error-page">
        <i class="el-icon-error"></i>
        <div>错误的请求</div>
    </div>
</template>

<script>
export default {
    name: 'ErrorPage'
}
</script>

<style lang="scss">
.error-page {
    height: 100vh;
    width: 100vw;
    text-align: center;

    i {
        margin-top: 20vh;
        font-size: 48px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Error.vue